import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, take } from 'rxjs/operators';

import { ProductSkuFilterRequest } from '@shared/models/request/product-sku-filter-request';

import { HttpService } from '@shared/services/http.service';
import {SessionStoreService} from "@shared/services/session-store.service";

const SEND_SUBSCRIBE_US = 'common/subscribe-us';

@Injectable({
  providedIn: 'root'
})
export class SubscribeUsService{

  constructor(private httpService: HttpService, private ss: SessionStoreService) { }

  sendSubscribeUsEmail(subscribeUsRequest: any): Observable<any> {
    return this.httpService.post(SEND_SUBSCRIBE_US, { body: subscribeUsRequest });
  }

}
